"use client";

import React, { useState } from "react";

// Types
import { ImageTableProps } from "@/types";

// Styles
import * as S from "./styles";

// Imagem padrão
import ImageDefault from "@/assets/images/default-slider-image.png";

const ImageTabel: React.FC<ImageTableProps> = ({ src, onClick }) => {
  return <S.ImageTable src={src || ImageDefault} onClick={onClick} />;
};

export default ImageTabel;
